<template lang="pug">
section.main(:class="collapsed ? 'wide' : 'narrow'")
  Header(ref="header")
  Menu
  section.page.setup
    h1.title
      i.icon.fas.fa-cog
      span {{ page.title }}
    section.body.d-flex.flex-row
      section.left.d-flex.align-items-stretch
        OtherMenu
      section.right.d-flex.align-items-stretch
        template
          Profile(v-if="feature === 'profile'")
          Preference(v-if="feature === 'preference'")
          Password(v-if="feature === 'password'")
          Billings(v-if="feature === 'billings'")
          Payment(v-if="feature === 'payment'")
          Company(v-if="feature === 'company'")
          Usage(v-if="feature === 'usage'")
</template>

<script>
// import { getData } from '../utils/api'

const page = {
  id: 'setup',
  title: '設定・変更'
}

export default {
  name: page.id,
  props: ['mode'],
  data () {
    return {
      mask: false,
      app: {
        name: process.env.VUE_APP_NAME
      },
      page: page,
      collapsed: true,
      feature: null
    }
  },
  watch: {
    '$route' (to, from) {
      const routes = to.path.split('/').slice(1)
      if (routes.length > 1) {
        this.feature = routes[1]
      }
    }
  },
  mounted () {
    const routes = this.$route.path.split('/').slice(1)
    if (routes.length > 1) {
      this.feature = routes[1]
    }
  },
  methods: {
    async loadData () {
      this.mask = true
      this.mask = false
    },
    handleTab (feature) {
      if (feature.indexOf('/') > -1) {
        this.feature = feature.split('/')[0]
      } else {
        this.feature = feature
      }
      this.handleLink(`/${this.$route.params.directory}/setup/${feature}`)
    }
  }
}
</script>

<style scoped lang="stylus">
.page
  .title
    button.add
      right 1.875rem
  .body
    min-height calc(100vh - 71px - 75px)

  .nav
    .nav-item
      &.active, &.active a
        //pointer-events none
        //cursor default
</style>
